<template>
  <div class="w-100 font-inter">
    <div class="header">
      <div class="text-14 font-weight-500 text-grey-black-2">
        {{ title }}
      </div>
      <div v-if="number" class="text-24 font-weight-600">{{ number }}</div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DashboardItem",
  props: {
    title: {
      type: String,
      default: "",
    },
    number: {
      type: String | Number,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// DashboardItem.vue?543857d5